import { render } from "./Warch.vue?vue&type=template&id=39ba18c0"
import script from "./Warch.vue?vue&type=script&lang=js"
export * from "./Warch.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__